import React from "react";

const IconClose = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.63623 15L14.9997 1"
      stroke="#999999"
      strokeWidth="0.963"
      strokeLinecap="round"
    />
    <path
      d="M14.3635 15L1 1"
      stroke="#999999"
      strokeWidth="0.963"
      strokeLinecap="round"
    />
  </svg>
);

export default IconClose;
